import React from "react";

import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function Card ({item}) {
    return (
        <div className={style.card}>
            <div className={style.cardInner}>
                {
                    item.image !== "" && (
                        <div className={style.cardImage}>
                            <div className={style.cardImageSizer}></div>
                            <Background src={item.image} size="330x240" cPosition="topLeft" />
                            {
                                item.url !== "" && (
                                    <Link to={item.url} className={style.fullBlock}></Link>
                                )
                            }
                        </div>
                    )
                }
                {
                    item.title !== "" && item.url !== "" && (
                        <div className={style.cardBottom}>
                            <Spacer size="32" />
                            <Link 
                                to={item.url}
                            >
                                <Title className="fontTeko" tag="h4">{item.title}</Title>
                            </Link>
                        </div>
                    )
                }
            </div>
        </div>
    )
}